/**
 * node_modules
 */
import { useStaticQuery, graphql } from "gatsby"

/**
 * components
 */
import { News as NewsList, NewsItemType } from "@components/News"

/**
 * @function News
 * @description HOME/Newsセクション
 * TOPページ用ニュース
 */
export const News = () => {
  /**
   * query
   */
  const data: Queries.NewsQuery = useStaticQuery(graphql`
    query News {
      camp {
        news(location: "headquarter") {
          id
          location
          label
          title
          linkUrl
          publishedAt
        }
      }
    }
  `)

  const { news } = data.camp
  const shouldShowNews = news.length >= 1

  return shouldShowNews && <NewsList news={news as [NewsItemType]} />
}
